<template>
  <v-data-table
      :headers="headers"
      :items="messageTemplates">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Message templates</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical>
          </v-divider>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialog"
            max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="ml-1 mb-2"
                v-bind="attrs"
                @click="resetCurrentItem()"
                v-on="on">
                New Item
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <ValidationObserver ref="messageTemplate" v-slot="{ invalid, valid, errors }">
                  <v-form v-model="messageTemplateValid">
                    <v-container>
                      <v-row>
                      <v-col cols="12">
                          <ValidationProvider
                            rules="required"
                            name="Short description"
                            vid="shortDescription"
                            v-slot="{ errors }">
                            <v-text-field
                              v-model="editedItem.shortDescription"
                              :error-messages="errors"
                              label="Short description"
                              append-icon="mdi-card-bulleted-outline"
                              placeholder="'Enter short description'">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                      <v-col cols="12">
                        <ValidationProvider
                            rules="required"
                            name="Message text"
                            vid="messageText"
                            v-slot="{ errors }">
                            <v-textarea
                              :error-messages="errors"
                              v-model="editedItem.messageText"
                              label="Message text">
                            </v-textarea>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </ValidationObserver>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close">
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="saveTemplate">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title>
                Are you sure you want to delete this item?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteTemplateConfirmed">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
       <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editTemplate(item)">
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="deleteTemplate(item)">
          mdi-eraser
        </v-icon>
      </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import storeConstants from '@/store/storeConstants';

setInteractionMode('eager');
extend('required', required);

export default {
  name: 'messageTemplates',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    messageTemplateValid: false,
    messageTemplates: [],
    editedItem: {},
    deleteItem: {},
    defaultItem: {
      templateId: undefined,
      shortDescription: undefined,
      messageText: undefined,
    },
    editedIndex: -1,
    headers: [{
      text: 'Actions',
      value: 'actions',
      sortable: false,
      width: 100,
    },
    {
      text: 'Id',
      align: 'start',
      value: 'templateId',
    },
    { text: 'Short description', value: 'shortDescription' },
    { text: 'Message template text', value: 'messageText' },
    ],
  }),
  computed: {
    ...mapGetters([storeConstants.MESSAGE_TEMPLATES]),
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    },
  },
  mounted() {
    this.GET_MESSAGE_TEMPLATES()
      .then(() => {
        this.messageTemplates = this.MESSAGE_TEMPLATES;
        this.isLoading = false;
      },
      (error) => {
        this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
  watch: {
    dialogDelete(val) {
      return val || this.closeDelete();
    },
  },
  methods: {
    ...mapActions([storeConstants.GET_MESSAGE_TEMPLATES,
      storeConstants.SAVE_MESSAGE_TEMPLATE,
      storeConstants.DELETE_MESSAGE_TEMPLATE]),
    resetCurrentItem() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    deleteTemplate(item) {
      this.deleteItem = item;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.deleteItem = null;
      this.dialogDelete = false;
    },
    deleteTemplateConfirmed() {
      this.DELETE_MESSAGE_TEMPLATE(this.deleteItem.templateId)
        .then(() => {
          this.messageTemplates = this.MESSAGE_TEMPLATES;
          this.deleteItem = null;
          this.dialog = false;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      this.dialogDelete = false;
    },
    editTemplate(item) {
      this.editedIndex = this.messageTemplates.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    saveTemplate() {
      this.$refs.messageTemplate.validate().then((success) => {
        this.messageTemplateValid = success;
        if (this.messageTemplateValid) {
          this.SAVE_MESSAGE_TEMPLATE(this.editedItem)
            .then(() => {
              this.messageTemplates = this.MESSAGE_TEMPLATES;
              this.dialog = false;
            },
            (error) => {
              this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    cancel() {
      this.dialog = false;
    },
  },
};
</script>
